import { pageInfo, downtemplate, uploadMateriel, deleteData, materielEdit, submit, deleteBatch } from './../api'
import { exportData } from '../../customMaterial/api'
const customer = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    downtemplateObj: null,
    uploadMaterielObj: null,
    deleteDataObj: null,
    exportDataObj: null,
    materielEditData: null,
    submitData: null,
    deleteBatchObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    DOWN_TEMPLATE_DATA(state,data){
      state.downtemplateObj = data;
    },
    UPLOAD_MATERIEL_DATA(state,data){
      state.uploadMaterielObj = data;
    },
    DELETE_DATA(state,data){
      state.deleteDataObj = data;
    },
    EXPORT_DATA(state,data){
      state.exportDataObj = data;
    },
    EDIT_DATA(state,data){
      state.materielEditData = data.obj || {};
    },
    SUBMIT_DATA(state,data){
      state.submitData = data;
    },
    DELETE_BATCH_DATA(state,data){
      state.deleteBatchObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async downtemplate({commit}, obj){
      let resp = await downtemplate(obj);
      commit('DOWN_TEMPLATE_DATA', resp);
    },
    async uploadMateriel({commit}, obj){
      let resp = await uploadMateriel(obj);
      commit('UPLOAD_MATERIEL_DATA', resp);
    },
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    async exportData({commit}, obj){
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async materielEdit({commit}, obj){
      let resp = await materielEdit(obj);
      commit('EDIT_DATA', resp);
    },
    async submit({commit}, obj){
      let resp = await submit(obj);
      commit('SUBMIT_DATA', resp);
    },
    async deleteBatch({commit}, obj){
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH_DATA', resp);
    }
  }
}
export default customer



// WEBPACK FOOTER //
// ./src/page/md/customMaterial/store/customMaterial.store.js